import { render, staticRenderFns } from "./LoginFrom.vue?vue&type=template&id=498e61c6&scoped=true"
import script from "./LoginFrom.vue?vue&type=script&lang=js"
export * from "./LoginFrom.vue?vue&type=script&lang=js"
import style0 from "./LoginFrom.vue?vue&type=style&index=0&id=498e61c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498e61c6",
  null
  
)

export default component.exports